import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components/macro';

import { Box } from '@olist/united';

const Skeleton = styled(Box)`
  background-color: ${themeGet('colors.foundation.shadeLighter')};
  overflow: hidden;
  position: relative;

  &::before {
    animation: skeletonLoading 2s infinite;
    background: linear-gradient(
      to right,
      transparent 0%,
      ${themeGet('colors.foundation.shadeWhite')} 50%,
      transparent 100%
    );
    content: '';
    display: block;
    height: 100%;
    position: absolute;
    width: 100px;
  }

  @keyframes skeletonLoading {
    0% {
      left: -100px;
    }
    100% {
      left: 100%;
    }
  }
`;

export default Skeleton;
